<template>
  <div>

    <!-- Cuenta de haberes -->
    <div class="flex flex-wrap -mx-2">
      <div class="w-full mb-2 px-2">
        <h2 class="form-subtitle">Cuenta de haberes</h2>
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Tipo de documento"
          :required="hasBankSelected"
          v-model="form.bankIdentifierType"
          :items="identifierTypes"
          defaultOption="Elegir tipo"
          :disabled="true"
          :error="v.bankIdentifierType && v.bankIdentifierType.$error && !v.bankIdentifierType.required
            ? 'Tipo de documento es requerido' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Número de documento"
          :required="hasBankSelected"
          :value="form.bankIdentifier"
          :disabled="true"
          :error="v.bankIdentifier && v.bankIdentifier.$error && !v.bankIdentifier.required
            ? 'Número de documento es requerido' : ''"
        />
      </div>

      <div class="w-full mb-3 px-2">
        <wz-input
          label="Titular de la cuenta"
          :required="hasBankSelected"
          :value="form.bankHolder"
          :disabled="true"
          :error="v.bankHolder && v.bankHolder.$error && !v.bankHolder.required
            ? 'Titular es requerido' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Banco"
          v-model="form.bankId"
          :items="banks"
          defaultOption="Elegir banco"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Tipo de cuenta"
          :required="hasBankSelected"
          v-model="form.accountType"
          :items="accountTypes"
          defaultOption="Elegir tipo de cuenta"
          :error="v.accountType && v.accountType.$error && !v.accountType.required
            ? 'Tipo de cuenta es requerido' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Número de cuenta"
          :required="hasBankSelected"
          v-model="form.bankAccount"
          placeholder="Ingresar número de cuenta"
          maxlength="20"
          :error="v.bankAccount && v.bankAccount.$error && !v.bankAccount.required
            ? 'Número de cuenta es requerido' : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="CCI"
          v-model="form.bankInterAccount"
          placeholder="Ingresar CCI (20 dígitos)"
          maxlength="20"
          :error="v.bankInterAccount && v.bankInterAccount.$error
            ? (!v.bankInterAccount.numeric    ? 'CCI debe ser numérico'
              : !v.bankInterAccount.minLength ? 'CCI debe tener 20 dígitos' : '')
            : ''"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Moneda"
          v-model="form.salaryCurrency"
          :items="currencyList"
          defaultOption="Elegir moneda"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <div class="flex items-center mt-4 pt-2">
          <label class="wz-form-label mb-0 mr-3">Datos bancarios confirmados</label>
          <wz-checkbox
            v-model="form.bankAccountVerified"
            name="bankAccountVerified"
            switch
            size="lg"
          />
        </div>
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2" v-if="form.bankAccountVerified">
        <wz-input
          label="Confirmado por"
          :value="form.bankAccountVerifiedBy"
          :disabled="true"
        />
      </div>
    </div>

    <!-- CTS -->
    <div class="flex flex-wrap mt-2 -mx-2">
      <div class="w-full mb-2 px-2">
        <h2 class="form-subtitle">CTS</h2>
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Banco CTS"
          v-model="form.ctsBankId"
          :items="banks"
          defaultOption="Elegir banco CTS"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Cuenta CTS"
          v-model="form.ctsAccount"
          placeholder="Ingresar cuenta CTS"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Moneda CTS"
          v-model="form.ctsCurrency"
          :items="currencyList"
          defaultOption="Elegir moneda"
        />
      </div>
    </div>

    <!-- Sistema pensionario -->
    <div class="flex flex-wrap mt-2 -mx-2">
      <div class="w-full mb-2 px-2">
        <h2 class="form-subtitle">Sistema pensionario</h2>
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Sistema previsional"
          v-model="form.pensionSystem"
          :items="pensionSystemList"
          defaultOption="Elegir sistema"
        />
      </div>

      <template v-if="form.pensionSystem === 'AFP'">
        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-select
            label="Entidad AFP"
            :required="form.pensionSystem === 'AFP'"
            v-model="form.pensionEntityId"
            :items="pensionEntities"
            defaultOption="Elegir AFP"
            :error="v.pensionEntityId && v.pensionEntityId.$error && !v.pensionEntityId.required
              ? 'La entidad AFP es requerida' : ''"
          />
        </div>

        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-input
            label="Código CUSPP"
            v-model="form.cusppCode"
            placeholder="Ingresar código CUSPP"
          />
        </div>

        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-select
            label="Tipo de comisión AFP"
            v-model="form.afpCommissionType"
            :items="afpCommissionTypeList"
            defaultOption="Elegir tipo"
          />
        </div>
      </template>

      <template v-if="form.pensionSystem === 'SIN_REGIMEN' || form.pensionSystem === 'JUBILADO'">
        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-select
            label="Entidad pensionaria"
            v-model="form.pensionEntityId"
            :items="filteredPensionEntities"
            defaultOption="—"
            :disabled="filteredPensionEntities.length === 1"
          />
        </div>
      </template>
    </div>

    <!-- Tributario -->
    <div class="flex flex-wrap mt-2 -mx-2">
      <div class="w-full mb-2 px-2">
        <h2 class="form-subtitle">Tributario</h2>
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Situación 5ta categoría"
          v-model="form.fifthCategoryStatus"
          :items="fifthCategoryStatusList"
          defaultOption="Elegir situación"
        />
      </div>
    </div>

    <!-- Renta 5ta: ingresos de empleador anterior (solo si AFECTO) -->
    <prior-income-section
      :employee-id="employeeId"
      :fifth-category-status="form.fifthCategoryStatus"
    />

  </div>
</template>

<script>
import { Constants } from '@/core/utils'
import PriorIncomeSection from '@/modules/Employees/components/PriorIncomeSection.vue'

export default {
  components: { PriorIncomeSection },
  props: {
    form:            { type: Object, required: true },
    v:               { type: Object, required: true },
    banks:           { type: Array,  default: () => [] },
    pensionEntities: { type: Array,  default: () => [] },
    employeeId:      { type: [Number, String], default: null },
  },
  data() {
    return {
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASAPORTE,
        Constants.IdentifierType.LIBRETA_MILITAR,
        Constants.IdentifierType.CARNET_MILITAR,
      ],
      accountTypes: [
        Constants.AccountType.SAVINGS,
        Constants.AccountType.CURRENT,
        Constants.AccountType.SALARY,
      ],
      currencyList:            Object.values(Constants.SalaryCurrency),
      pensionSystemList:       Object.values(Constants.PensionSystem),
      afpCommissionTypeList:   Object.values(Constants.AfpCommissionType),
      fifthCategoryStatusList: Object.values(Constants.FifthCategoryStatus),
    }
  },
  computed: {
    hasBankSelected() {
      return !!this.form.bankId
    },
    filteredPensionEntities() {
      const codeMap = { SIN_REGIMEN: 'SINRP', JUBILADO: 'JUBIL' }
      const code = codeMap[this.form.pensionSystem]
      if (!code) return []
      return this.pensionEntities.filter(e => e.code === code)
    },
  },

  watch: {
    'form.pensionSystem'(val) {
      if (val === 'AFP') {
        this.form.pensionEntityId = null
      } else if (val === 'SIN_REGIMEN' || val === 'JUBILADO') {
        this.$nextTick(() => {
          if (this.filteredPensionEntities.length === 1) {
            this.form.pensionEntityId = this.filteredPensionEntities[0].key
          }
        })
      } else {
        this.form.pensionEntityId = null
      }
    },
  },
}
</script>

<style lang="stylus" scoped></style>
